module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Invoice For Billing - Sea Export")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.proceedAssignmentProforma(
          _vm.ffInvoiceModal.allModuleId,
          _vm.ffInvoiceModal.isConsolidation,
          _vm.ffInvoiceModal.jobNo
        )
      }
    }
  }, [_vm._v("Proceed To Proforma")])], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.ffInvoiceModal.allModuleId ? this.ffInvoiceModal.allModuleId : '',
      "jobSeriesBanner": this.ffInvoiceModal.jobNo ? this.ffInvoiceModal.jobNo : '',
      "bannerClientName": this.ffInvoiceModal.clientName ? this.ffInvoiceModal.clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.sentForApproval == '1' && _vm.chnageApprovalStatus != '1') ? _c('h4', {
    staticClass: "mt-3 error"
  }, [_vm._v("\n              Invoice Sent For Approval\n            ")]) : _vm._e(), _vm._v(" "), (_vm.PreviousPerformaList.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body row"
  }, _vm._l((_vm.PreviousPerformaList), function(pre_item, pre_index) {
    return _c('div', {
      key: pre_index,
      staticClass: "col-md-2"
    }, [(pre_item.profarmaSeries) ? _c('b-button', {
      staticClass: "mt-2",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.getPreviousTallyData(pre_item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(pre_item.profarmaSeries))])]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Job No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "jobNo", $$v)
      },
      expression: "ffInvoiceModal.jobNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientName", $$v)
      },
      expression: "ffInvoiceModal.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.ffInvoiceModal.invoiceStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "invoiceStatus", $$v)
      },
      expression: "ffInvoiceModal.invoiceStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POR),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POR", $$v)
      },
      expression: "ffInvoiceModal.POR"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.PORError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.PORError) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.LP),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "LP", $$v)
      },
      expression: "ffInvoiceModal.LP"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.LPError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.LPError) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POD", $$v)
      },
      expression: "ffInvoiceModal.POD"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.PODError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.PODError) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "FPOD", $$v)
      },
      expression: "ffInvoiceModal.FPOD"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.FPODError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.FPODError) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(this.newContainerFlow == '0') ? _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ Date (MM/DD/YY)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.BOE),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "BOE", $$v)
      },
      expression: "ffInvoiceModal.BOE"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.BOEError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.BOEError) + "\n                  ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("BL No")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.blNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "blNo", $$v)
      },
      expression: "ffInvoiceModal.blNo"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.blNoError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.blNoError) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("MBL Release Date")]), _c('br'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('date-picker', {
    staticClass: "mt-2",
    style: ({
      width: '500px'
    }),
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "validityDate",
      "id": "validityDate"
    },
    model: {
      value: (_vm.ffInvoiceModal.mbl_release_date),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "mbl_release_date", $$v)
      },
      expression: "ffInvoiceModal.mbl_release_date"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.mbl_release_dateError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.mbl_release_dateError) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (this.newContainerFlow == '0') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvNo", $$v)
      },
      expression: "ffInvoiceModal.shipperInvNo"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.shipperInvNoError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.shipperInvNoError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date (MM/DD/YY)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvDate),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvDate", $$v)
      },
      expression: "ffInvoiceModal.shipperInvDate"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.shipperInvDateError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.shipperInvDateError))]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.vessel),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "vessel", $$v)
      },
      expression: "ffInvoiceModal.vessel"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.vesselError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.vesselError) + "\n                  ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight (KGS)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.weight),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "weight", $$v)
      },
      expression: "ffInvoiceModal.weight"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.weightError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n                    " + _vm._s(_vm.ffInvoiceModal.weightError) + "\n                  ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shippingLine", $$v)
      },
      expression: "ffInvoiceModal.shippingLine"
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.shippingLineError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.shippingLineError))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered pl-2 pr-2 mt-3",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Shipper Inv & Date")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bill & Date")]), _vm._v(" "), _c('th', [_vm._v("Gross Wgt.")]), _vm._v(" "), _c('th', [_vm._v("BL Number")])]), _vm._v(" "), _vm._l((_vm.containerTypeDetailFactory), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item.shipperInvoiceNo) + " |\n                    " + _vm._s(item.shipperInvoiceDate) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shippingBillNo) + " | " + _vm._s(item.shippingBillDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.grossWeight) + " " + _vm._s(item.weightUnit))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bl))])])
  })], 2)]), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.ffInvoiceModal.allModuleId)
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Payment-Summary', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Charges")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('span', {
    staticClass: "error mt-4"
  }, [_vm._v("\n                  Note : Approval will be required when Selling Rate is less than\n                  Quotation Rate.!\n                ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error mt-1"
  }, [_vm._v("* marked heads are mandatory..!")])]), _vm._v(" "), _c('table', {
    staticClass: "table mt-3 table-light table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('th', [_vm._v("Particulars*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("Container Type*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("Quantity*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "125px"
    }
  }, [_vm._v("Quotation Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "125px"
    }
  }, [_vm._v("Selling Rate*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "125px"
    }
  }, [_vm._v("Currency*/Exch Rate*/Unit*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "125px"
    }
  }, [_vm._v("Invoice Amount(Without Taxes)*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.ffTallyInvoiceData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [(_vm.ffTallyInvoiceData.length > 1) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-info"
      },
      on: {
        "click": function($event) {
          _vm.removeCol(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "list": _vm.$store.getters['common/getAllLedgerList'],
        "option-value": "ledger",
        "option-text": "ledger",
        "placeholder": "Select Particular"
      },
      model: {
        value: (item.ffType),
        callback: function($$v) {
          _vm.$set(item, "ffType", $$v)
        },
        expression: "item.ffType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": ""
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.ffSellingRate),
        callback: function($$v) {
          _vm.$set(item, "ffSellingRate", $$v)
        },
        expression: "item.ffSellingRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.sellingRateFinal),
        callback: function($$v) {
          _vm.$set(item, "sellingRateFinal", $$v)
        },
        expression: "item.sellingRateFinal"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "list": _vm.currencyList,
        "option-value": "currencyV",
        "option-text": "currencyT",
        "placeholder": "Select"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    }), _vm._v(" "), _c('b-form-input', {
      staticClass: "mt-2",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.exchRate),
        callback: function($$v) {
          _vm.$set(item, "exchRate", $$v)
        },
        expression: "item.exchRate"
      }
    }), _vm._v(" "), _c('model-list-select', {
      staticClass: "mt-2",
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName",
        "placeholder": "Select"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' && !item.mainffId ? true : false,
        "type": "number"
      },
      model: {
        value: (item.invAmount),
        callback: function($$v) {
          _vm.$set(item, "invAmount", $$v)
        },
        expression: "item.invAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  })], 2)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold",
      "font-size": "16px"
    }
  }, [_vm._v("\n              Note: Dear User, Kindly check and upload the below Documents before\n              Sending this Assignment for Billing to Accounts:\n            ")]), _vm._v(" "), _c('div', [_c('b-form-group', [_c('b-form-checkbox-group', {
    attrs: {
      "id": "checkbox-group-1",
      "options": _vm.acceptCheck,
      "name": "flavour-2a",
      "stacked": ""
    },
    model: {
      value: (_vm.ffInvoiceModal.getAcceptOptions),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "getAcceptOptions", $$v)
      },
      expression: "ffInvoiceModal.getAcceptOptions"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.MBLFlag) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeTxt",
      "placeholder": "Select Shipment Type"
    },
    model: {
      value: (_vm.MBLData.bl_shipment_type),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "bl_shipment_type", $$v)
      },
      expression: "MBLData.bl_shipment_type"
    }
  }), _vm._v(" "), (!_vm.MBLData.bl_shipment_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.bl_shipment_type))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("B/L Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": true,
      "list": _vm.blTypeList,
      "option-value": "blTypeVal",
      "option-text": "blTypeTxt",
      "placeholder": "Select B/L Type"
    },
    model: {
      value: (_vm.MBLData.blType),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "blType", $$v)
      },
      expression: "MBLData.blType"
    }
  }), _vm._v(" "), (!_vm.MBLData.blType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.blType))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsLinerListName,
      "option-value": "frghtTermsLinerVal",
      "option-text": "frghtTermsLinerTxt",
      "placeholder": "Select Freght Terms"
    },
    model: {
      value: (_vm.MBLData.frghtTermsLiner),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "frghtTermsLiner", $$v)
      },
      expression: "MBLData.frghtTermsLiner"
    }
  }), _vm._v(" "), (!_vm.MBLData.frghtTermsLiner) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.frghtTermsLiner))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("MBL Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "linerBLNumber",
      "name": "linerBLNumber"
    },
    model: {
      value: (_vm.MBLData.linerBLNumber),
      callback: function($$v) {
        _vm.$set(_vm.MBLData, "linerBLNumber", $$v)
      },
      expression: "MBLData.linerBLNumber"
    }
  }), _vm._v(" "), (!_vm.MBLData.linerBLNumber) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLNumber))]) : _vm._e()], 1), _vm._v(" "), (_vm.MBLData.bl_shipment_type !== 'NOMINATION' && _vm.MBLData.blType !== 'HouseBL') ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("MBL Upload")]), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('multi-file-uploader', {
    style: ("height: 79px;    background: darkgray;    width: 300px;"),
    attrs: {
      "documentName": 'Liner BL',
      "otherDocName": 'Liner BL',
      "folderName": 'Doc Library',
      "accept": '*',
      "assign_no": _vm.ffInvoiceModal.jobNo,
      "multiple": false,
      "state": Boolean(_vm.singleUpload),
      "fileAllModuleId": _vm.ffInvoiceModal.allModuleId
    },
    model: {
      value: (_vm.singleUpload),
      callback: function($$v) {
        _vm.singleUpload = $$v
      },
      expression: "singleUpload"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('span', [_vm._v("Choose a file or drop it above...")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorMBLList.linerBLupload))])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "ml-2",
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "disabled": _vm.MBLFlag == true ? true : false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.saveMBL
    }
  }, [_vm._v("Save MBL")])], 1)], 1) : _c('b-row', [(_vm.MBLList.length > 0) ? _c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("BL Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Liner Freght Terms")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("MBL Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("PDF")])]), _vm._v(" "), _vm._l((_vm.MBLList), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [(itm.bl_shipment_type) ? _c('span', [_vm._v(_vm._s(itm.bl_shipment_type))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.blType))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.frghtTermsLiner))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.blType) ? _c('span', [_vm._v(_vm._s(itm.linerBLNumber))]) : _vm._e()]), _vm._v(" "), _c('td', [(itm.linerBLupload) ? _c('span', [_c('b-button', {
      staticClass: "text-danger",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-warning",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.PrintNote(itm.linerBLupload, _vm.ffInvoiceModal.jobNo)
        }
      }
    }, [_vm._v("PDF")])], 1) : _vm._e()])])
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId && _vm.is_noe_validation) ? _c('ExpenseTableComponent', {
    ref: "expenseTableComponent",
    attrs: {
      "show-debug": false,
      "initial-expenses": _vm.initialExpenses,
      "enable-validation": true,
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "jobNo": _vm.ffInvoiceModal.jobNo,
      "moduleType": 'FF',
      "transportType": 'Export',
      "branchId": _vm.$sessionsStorage.get('branch_baseLocation'),
      "invoiceStatus": _vm.ffInvoiceModal.invoiceStatus
    },
    on: {
      "expenses-saved": _vm.handleExpensesSaved,
      "expense-validation": _vm.handleExpenseValidation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "type": 'additional-task'
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center",
    attrs: {
      "md-flex": "100"
    }
  }, [(_vm.validateTally == false && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "disabled": _vm.DisableSubmit === 0 && _vm.validSubmit === true ? true : false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('1')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ffInvoiceModal.invoiceStatus == "0" ?
    "Save & Submit To Accounts" :
    "Save") + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "25px",
      "padding-left": "20px"
    }
  }, [_vm._v("\n                  Last Updated At :\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.updatedTime))]), _vm._v(" , By :\n                  "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('br'), _vm._v(" "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .BillingSeriesDataString
  ) ? _c('div', [_vm._v("\n                    Invoice No.\n                    "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters["common/getAllSuccessInvoiceTB"]
    .BillingSeriesDataString))]), _vm._v("\n                    genrated.\n                    "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .InvoiceTypeKeyFlag == true
  ) ? _c('span', [_vm._v("Cannot be re-submitted")]) : _vm._e()]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [(_vm.validateTally == true && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "disabled": _vm.DisableSubmit == '0' ? true : false,
      "variant": "dark"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('2')
      }
    }
  }, [_vm._v("Send For Approval")]) : _vm._e()], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-709931d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/freightInvoiceForTally.vue
// module id = 2741
// module chunks = 0